import { SelectBoxOpt } from '@/components/content/SelectBox'

// 출고대기수량 예측 패널에서 선택 가능한 화주 (출고일정관리 2.5의 PLATFORM_OPTIONS와 동일 정책)
export const WAIT_VOLUME_SHIPPER_OPTIONS: SelectBoxOpt<string>[] = [
  { label: 'MUSINSA', value: 'MUSINSA' },
  { label: '29CM', value: '29CM' },
  { label: 'MUSINSA_USED', value: 'MUSINSA_USED' },
]
